/<template>
  <!-- <div> -->
  <v-card :elevation="0">
    <v-card-title>
      <!-- <h2>Strategy Review</h2> -->
      <h2>{{ step_label }}</h2>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="stepHeaders"
      :items="strategies"
      :search="search"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 30, -1]
      }"
      :items-per-page="-1"
      item-key="name"
      class="elevation-1"
      dense
      :loading="false"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td :style="highlightColumn(1,1,null)" class="text-left" >{{ item.name }}</td>
          <td :style="highlightColumn(2,2,'L')" class="text-center">{{ item.pearls }}</td>
          <td :style="highlightColumn(2,2,null)" class="text-center">{{ item.oysters }}</td>
          <td :style="highlightColumn(2,2,null)" class="text-center">{{ item.breadandbutter }}</td>
          <td :style="highlightColumn(2,2,'R')" class="text-center">{{ item.whiteelephant }}</td>
          <td :style="highlightColumn(3,4,'L')" class="text-center">{{ item.unfundedSuccesses }}</td>
          <td :style="highlightColumn(3,4,'R')" class="text-center">{{ item.unfundedValue }}</td>
          <td :style="highlightColumn(5,6,'L')" class="text-center">{{ item.fundedSuccesses }}</td>
          <td :style="highlightColumn(5,6,'R')" class="text-center">{{ item.fundedValue }}</td>

          <td v-if="gameStep>6" :style="highlightColumn(7,8,'L')" class="text-center"> {{ item.bestFiveValue }}</td>
          <td v-if="gameStep>6" :style="highlightColumn(7,8,'R')" class="text-center "> {{ item.valueOysPearl }} </td>
          <!-- <div v-if="gameStep>6"> -->
          <!-- <td v-if="gameStep>7" class="text-center title custom-highlight-column">
            {{ item.bestFiveValue }}
           <td v-if="gameStep>7" class="text-center title custom-highlight-column">
            {{ item.valueOysPearl }}
          </td> -->
          <!-- </div> -->
        </tr>
      </template>

      <template v-if="strategies.length>0" slot="body.append">
        <tr class="pink--text">
          <!-- <div v-if="gameStep>1"> -->
          <th class="text-center title">Averages</th>
          <th v-if="gameStep>1" class="text-center title">{{ avgField("pearls") }}</th>
          <th v-if="gameStep>1" class="text-center title">{{ avgField("oysters") }}</th>
          <th v-if="gameStep>1" class="text-center title">{{ avgField("breadandbutter") }}</th>
          <th v-if="gameStep>1" class="text-center title">{{ avgField("whiteelephant") }}</th>
          <!-- </div> -->
          <!-- <div v-if="gameStep>2"> -->
          <th v-if="gameStep>3" class="text-center title">{{ avgField("unfundedSuccesses") }}</th>
          <th v-if="gameStep>3" class="text-center title">{{ avgField("unfundedValue") }}</th>
          
          <!-- <div v-if="gameStep>4"> -->
          <th v-if="gameStep>5" class="text-center title">{{ avgField("fundedSuccesses") }}</th>
          <th v-if="gameStep>5" class="text-center title">{{ avgField("fundedValue") }}</th>
          <!-- </div> -->
          <!-- <div v-if="gameStep>6"> -->
          <th v-if="gameStep>7" class="text-center title">{{ avgField("bestFiveValue") }}</th>
          <th v-if="gameStep>7" class="text-center title">{{ avgField("valueOysPearl") }}</th>
          <!-- </div> -->
        </tr>

         <tr v-if="gameStep>7" class="blue--text">
              <th class="text-center title">Historical Averages (n={{ this.historicalStrategies.length }})</th>
              <th class="text-center title">{{ historicalAvgField("pearls") }}</th>
              <th class="text-center title">{{ historicalAvgField("oysters") }}</th>
              <th class="text-center title">
                {{ historicalAvgField("breadandbutter") }}
              </th>
              <th class="text-center title">{{ historicalAvgField("whiteelephant") }}</th>
              <th class="text-center title">
                {{ historicalAvgField("unfundedSuccesses") }}
              </th>
              <th class="text-center title">{{ historicalAvgField("unfundedValue") }}</th>
              <th class="text-center title">
                {{ historicalAvgField("fundedSuccesses") }}
              </th>
              <th class="text-center title">{{ historicalAvgField("fundedValue") }}</th>
              <th class="text-center title">{{ historicalAvgField("bestFiveValue") }}</th>
              <th class="text-center title">{{ historicalAvgField("valueOysPearl") }}</th>
            </tr>
      </template>
    </v-data-table>
  </v-card>
  <!-- </div> -->
</template>

<script>
export default {
  props: ["step_label"],
  data() {
    return {
      header_indx: [5, 5, 7, 7, 9, 9, 10, 10],
      search: "",
      headers: [
        {
          text: "Name",
          align: "start",
          sortable: true,
          value: "name",
          class: "title"
        },
        {
          text: "Pearls",
          sortable: true,
          value: "pearls",
          class: "title",
          align: "center"
        },
        {
          text: "Oysters",
          sortable: true,
          value: "oysters",
          class: "title",
          align: "center"
        },
        {
          text: "Bread and Butter",
          sortable: true,
          value: "breadandbutter",
          class: "title",
          align: "center"
        },
        {
          text: "White Elephant",
          sortable: true,
          value: "whiteelephant",
          class: "title",
          align: "center"
        },
        {
          text: "Unfunded Successes",
          sortable: true,
          value: "unfundedSuccesses",
          class: "title",
          align: "center"
        },
        {
          text: "Unfunded Value",
          sortable: true,
          value: "unfundedValue",
          class: "title",
          align: "center"
        },
        {
          text: "Funded Successes",
          sortable: true,
          value: "fundedSuccesses",
          class: "title",
          align: "center"
        },
        {
          text: "Funded Value",
          sortable: true,
          value: "fundedValue",
          class: "title",
          align: "center"
        },
        {
          text: "Best 5 Value",
          sortable: true,
          value: "bestFiveValue",
          class: "title",
          align: "center"
        },
        {
          text: "Best 5 from Oysters/Pearl",
          sortable: true,
          value: "valueOysPearl",
          class: "title",
          align: "center"
        }
      ]
    };
  },

  computed: {
    strategies() {
      const currentGameID = this.$store.getters.currentGameID;
      const results = this.$store.getters.allResults.filter(
        obj => obj.gameID === currentGameID
      );
      console.log(results);
      return results;
    },
    historicalStrategies() {
      const result = this.$store.getters.allResults.filter(obj => obj.bestFiveValue !== null);
      return result.sort((a, b) => {
            return b.timestamp - a.timestamp;
          })
    },
    gameStep() {
      return this.$store.getters.groupGameStep;
    },
    stepHeaders() {
      const step = this.gameStep;
      let end = 0;
      if (step <= 2) end = 5;
      else if (step <= 4) end = 7;
      else if (step <= 6) end = 9;
      else end = this.headers.length;
      // if (step <= 2) {
      //   return this.headers.slice(0,5);
      // } else if (step <= 4) {
      //   return this.headers.slice(0,7);
      // }
      // console.log(this.headers.slice(0,end));
      return this.headers.slice(0, end);
    }
    // computedHeaders() {
    //   // if (this.gameStep <= 2) {
    //   //   return this.headers.slice(0,5);
    //   // } else if (this.gameStep <= 4) {
    //   //   return this.headers.slice(0,7);
    //   // }
    //   return this.headers;
    // }
  },
  methods: {
    highlightColumn(stepStart, stepEnd, y) {
      if (this.gameStep >= stepStart & this.gameStep <= stepEnd)
       return {backgroundColor: '#F7F7F7',
        borderLeft: (y === 'L' ? '4px solid grey' : ''),
        borderRight: (y === 'R' ? '4px solid grey' : '')
       };
      else 
        return {backgroundColor: 'transparent'};

      // {
      //   switch(step) {
      //     case 1:
      //       return {backgroundColor: '#F7F7F7'};
      //       break;
      //     case 2:
      //       return {backgroundColor: '#F7F7F7'}
      //       break;
      //     default:
      //       return {backgroundColor: '#F7F7F7'};
      //   }
      //   return {backgroundColor: 'transparent'};
      // }
      // const left = (y === 'L' ? '4px solid grey' : '');
      // if (x.resultID === this.resultID) {
      //   return {backgroundColor: '#E8E8E8', 
      //   color: '#951B20', 
      //   fontSize: '1.2em',
      //   fontWeight: 'bold',
      //   borderLeft: (y === 'L' ? '4px solid grey' : ''),
      //   borderRight: (y === 'R' ? '4px solid grey' : ''),
      //   };
      // } else {
      //   return {backgroundColor: (y === 'M' | y === 'L' | y === 'R' ? '#F7F7F7' : 'transparent'), 
      //   color: (y === 'M' | y === 'L' | y === 'R' ? 'blue' : ''),
      //   fontWeight: (y === 'M' | y === 'L' | y === 'R' ? 'bold' : ''),
      //   borderLeft: (y === 'L' ? '4px solid grey' : ''),
      //   borderRight: (y === 'R' ? '4px solid grey' : ''),
      //   };
      // }
    },


    avgField(key) {
      const nonNull = this.strategies.filter(obj => obj[key] !== null);
      const avg =
        this.strategies.reduce((a, b) => a + (b[key] || 0), 0) / nonNull.length;
      if (isNaN(avg) ) 
        return "";
      else
        return avg.toFixed(1);
    },

    historicalAvgField(key) {
      const nonNull = this.historicalStrategies.filter(obj => obj[key] !== null);
      const avg =
        this.historicalStrategies.reduce((a, b) => a + (b[key] || 0), 0) / nonNull.length;
      return avg.toFixed(1);
    }
  }
};
</script>


